export enum IProjectStatus {
    InProcess,
    OnHold,
    Published,
    Cancelled
}